module.exports = __webpack_public_path__ + "static/media/closeModal.b2b6f841.svg";